import React, { useState, useRef, useEffect } from 'react';

const CategoryDropdown = ({ category, setCategory }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const categories = [
    { value: 'all', label: 'All Categories', icon: '🌌', color: '#8b5cf6' },
    { value: 'remote', label: 'Remote Work', icon: '🌍', color: '#4A90E2' },
    { value: 'freelance', label: 'Freelance', icon: '⚡', color: '#F5A623' },
    { value: 'tech', label: 'Tech', icon: '💻', color: '#50E3C2' },
    { value: 'design', label: 'Design', icon: '🎨', color: '#FF6B6B' },
    { value: 'writing', label: 'Writing', icon: '✍️', color: '#845EF7' },
    { value: 'ai', label: 'AI', icon: '🤖', color: '#00B894' },
    { value: 'dev', label: 'Dev Tools', icon: '🛠️', color: '#6C5CE7' },
    { value: 'gaming', label: 'Gaming', icon: '🎮', color: '#E17055' },
    { value: 'tools', label: 'Tools', icon: '🔧', color: '#0984E3' },
    { value: 'rewards', label: 'Rewards', icon: '💰', color: '#FDCB6E' },
  ];

  const currentCategory = categories.find(c => c.value === category) || categories[0];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="custom-dropdown" ref={dropdownRef}>
      <div 
        className="dropdown-selected"
        onClick={() => setIsOpen(!isOpen)}
        style={{ borderColor: currentCategory.color }}
      >
        <span className="selected-icon">{currentCategory.icon}</span>
        <span className="selected-label">{currentCategory.label}</span>
        <span className={`dropdown-arrow ${isOpen ? 'open' : ''}`}>▼</span>
      </div>
      
      {isOpen && (
        <div className="dropdown-menu">
          {categories.map(cat => (
            <div
              key={cat.value}
              className={`dropdown-item ${category === cat.value ? 'active' : ''}`}
              onClick={() => {
                setCategory(cat.value);
                setIsOpen(false);
              }}
              style={{ '--hover-color': cat.color }}
            >
              <span className="item-icon">{cat.icon}</span>
              <span className="item-label">{cat.label}</span>
              {category === cat.value && <span className="item-check">✓</span>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CategoryDropdown;